<ion-grid>
  <form [formGroup]="materialForm">
    <ion-row>
      <mat-form-field *ngIf="displaySettings?.date" class="admia-form-date ion-padding-vertical">
        <mat-label>{{ texts.dayInfo.date | translate }}</mat-label>
        <input [formControl]="Date" [matDatepicker]="picker" matInput />
        <mat-datepicker-toggle [for]="picker" matSuffix></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
    </ion-row>

    <ion-row *ngIf="displaySettings?.number">
      <app-input-with-selection-list
        #inputFieldWithSelection
        class="admia-form-item ion-padding-top"
        [itemsService]="catalogueService"
        [itemsQuery]="materialCatalogueQuery"
        [labelTextKey]="texts.expenses.numberLong"
        [listRoute]="listRoute"
        [disabled$]="catalogueDisabled$"
        [inputFormControl]="Number"
      ></app-input-with-selection-list>
    </ion-row>

    <ion-row>
      <mat-form-field
        *ngIf="displaySettings?.name && !displaySettings?.nameAsCatalogueSelection"
        appearance="outline"
        class="admia-form-item ion-padding-top">
        <mat-label>{{ texts.expenses.name | translate }}</mat-label>

        <input
          [formControl]="Name"
          matInput
          maxlength="255"
          placeholder="{{ texts.expenses.name | translate }}"
          type="text"
        />

        <mat-icon
          (click)="listClick()"
          *ngIf="!displaySettings.number"
          matSuffix>
          <ion-icon name="ellipsis-vertical"> </ion-icon>
        </mat-icon>
      </mat-form-field>
    </ion-row>

    <ion-row
      *ngIf="displaySettings?.name && displaySettings?.nameAsCatalogueSelection">
      <app-input-with-selection-list
        #inputFieldWithSelectionDescription
        class="admia-form-item ion-padding-top"
        [itemsService]="catalogueService"
        [itemsQuery]="materialCatalogueQuery"
        key="description"
        [labelTextKey]="texts.general.name"
        [listRoute]="listRoute"
        [inputFormControl]="Name"
        [disabled$]="catalogueDisabled$">
      </app-input-with-selection-list>
    </ion-row>

    <ion-row>
      <mat-form-field
        *ngIf="displaySettings?.description"
        appearance="outline"
        class="admia-form-item ion-padding-top">
        <mat-label>{{ texts.expenses.description | translate }}</mat-label>

        <input
          [formControl]="Description"
          matInput
          maxlength="255"
          placeholder="{{ texts.expenses.description | translate }}"
          type="text"
        />
      </mat-form-field>
    </ion-row>

    <ion-row>
      <mat-form-field
        *ngIf="displaySettings?.quantity"
        appearance="outline"
        class="admia-form-item ion-padding-top">
        <mat-label>{{ texts.quantity.quantity | translate }}</mat-label>

        <input
          [formControl]="Quantity"
          matInput
          placeholder="{{ texts.quantity.quantity | translate }}"
          type="number"
        />
      </mat-form-field>
    </ion-row>

    <ion-row>
      <mat-form-field
        *ngIf="displaySettings?.unit"
        appearance="outline"
        class="admia-form-item ion-padding-top">
        <mat-label>{{ texts.items.unit | translate }}</mat-label>

        <input
          [formControl]="Unit"
          matInput
          maxlength="10"
          placeholder="{{ texts.items.unit | translate }}"
          type="text"
        />
      </mat-form-field>
    </ion-row>

    <ion-row>
      <mat-form-field
        *ngIf="displaySettings?.price"
        appearance="outline"
        class="admia-form-item ion-padding-top">
        <mat-label>{{ texts.items.price | translate }}</mat-label>

        <input
          [formControl]="Price"
          matInput
          placeholder="{{ texts.items.price | translate }}"
          type="number"
        />
      </mat-form-field>
    </ion-row>

    <ion-row *ngIf="displaySettings?.total">
      <ion-item class="admia-form-item total-item">
        <mat-label>{{ texts.general.total | translate }}:</mat-label>
        <ion-text class="ion-margin-start">{{ Total }}</ion-text>
      </ion-item>
    </ion-row>

    <ion-row *ngIf="displaySettings?.note">
        <ion-textarea class="admia-form-item ion-padding-top"
        [formControl]="Note"
        label="{{ texts.note.title | translate }}"
        labelPlacement="floating"
        fill="outline"
        rows="7" cols="20"
        [autoGrow]="true">
      </ion-textarea>
    </ion-row>
  </form>
</ion-grid>
